import { supabase } from '../supabase'

const FUNCTIONS_URL = process.env.REACT_APP_SUPABASE_FUNCTIONS_URL
const PASSWORD_CHARS = 'ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789'

async function getAuthHeader() {
  const { data: { session } } = await supabase.auth.getSession()
  return `Bearer ${session?.access_token}`
}

export function generarPasswordSegura(length = 10) {
  const values = new Uint32Array(length)
  crypto.getRandomValues(values)
  return Array.from(values, v => PASSWORD_CHARS[v % PASSWORD_CHARS.length]).join('')
}

export async function fetchPacientesParaExportacionAdmin(adminId) {
  const { data: profesionales } = await supabase
    .from('users')
    .select('id, nombre')
    .eq('creado_por', adminId)
    .eq('rol', 'profesional')

  const profNombre = Object.fromEntries((profesionales ?? []).map(p => [p.id, p.nombre]))
  profNombre[adminId] = 'Tú'
  const profIds = [adminId, ...(profesionales ?? []).map(p => p.id)]

  const { data, error } = await supabase
    .from('professional_patient')
    .select('profesional_id, patients ( id, nombre )')
    .in('profesional_id', profIds)

  if (error || !data) return []

  const seen = new Set()
  const result = []
  data.forEach(row => {
    if (!row.patients || seen.has(row.patients.id)) return
    seen.add(row.patients.id)
    result.push({ id: row.patients.id, nombre: row.patients.nombre, profesional: profNombre[row.profesional_id] ?? '' })
  })
  return result
}

export async function crearUsuario({ email, nombre, rol, altura_cm, fecha_nacimiento, sexo, profesional_id, password }) {
    const response = await fetch(`${FUNCTIONS_URL}/create-user`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': await getAuthHeader(),
      },
      body: JSON.stringify({ email, nombre, rol, altura_cm, fecha_nacimiento, sexo, profesional_id, password }),
    })
    const data = await response.json()
    if (!response.ok) throw new Error(data.error ?? 'Error al crear usuario')
    return data
  }